import EditorFotoKendaraanSection from "../../../../components/foto/EditorFotoKendaraanSection";
import TradoEditorFotoTrailerSection from "./TradoEditorFotoTrailerSection";

// Trado shows the photos of the vehicle AND the photos of the trailer.
const TradoEditorFotoSections = (props) => {
  return (
    <>
      <EditorFotoKendaraanSection {...props} />
      <TradoEditorFotoTrailerSection {...props} />
    </>
  );
};

export default TradoEditorFotoSections;
